import { Box, Stack } from "@mui/material";
import i18n from "src/i18n";

/**
 * Shipment Tour Steps:
 * 0: body (Welcome)
 * 1: #mapitShip-btn - MapitShip sidebar button
 * 2: #shipment-btn - Shipment button in sidebar
 * 3: #create-order-btn - Create shipment button
 * 4: .order-table - Order table
 * 5: #choses-company-order - Choose company
 * 6: body (Completion)
 */
export const shipmentTourSteps = (isMobile, isScrollableDrawer) => [
    {
        target: "body",
        title: <Stack justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/hand-up.webp" />
            {i18n.t("tutorial.shipmentTour.title")}
        </Stack>,
        content: i18n.t("tutorial.shipmentTour.step1"),
        placement: "center",
    },
    {
        target: "#mapitShip-btn",
        content: i18n.t("tutorial.shipmentTour.step2"),
        placement: "left",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },
    },
    {
        target: "#shipment-btn",
        content: i18n.t("tutorial.shipmentTour.step3"),
        placement: "top",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 445 : 450 : 0,
            },
        },
    },
    {
        target: "#create-order-btn",
        content: i18n.t("tutorial.shipmentTour.step4"),
        placement: "top",
    },
    {
        target: ".order-table",
        content: i18n.t("tutorial.shipmentTour.step5"),
        placement: "top",
    },
    {
        target: "#choses-company-order",
        content: i18n.t("tutorial.shipmentTour.step6"),
        placement: "top",
    },
    {
        target: "body",
        title: <Box display="flex" justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/rocket.png" />
        </Box>,
        content: i18n.t("tutorial.shipmentTour.end"),
        placement: "center",
    },
];
